// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import * as React from 'react';
import svg, { path } from 'react-native-svg';
function DrugIcon13(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.186.333A.333.333 0 0 0 23.852 0H8.146a.333.333 0 0 0-.334.333v2.6c0 .04 2.104 14.737 3.367 23.58v4.334A1.167 1.167 0 0 0 12.332 32h7.334a1.167 1.167 0 0 0 1.166-1.167V26.5c3.58-25.133 3.34-23.443 3.35-23.543.01-.1.004.29.004-2.624Zm-6.157 28.98a2.057 2.057 0 0 0-4.06 0h-2.123v-2.49h8.306v2.49H18.03Zm-.666 0h-2.697a1.39 1.39 0 0 1 2.7 0h-.003Zm2.15-26.046-9.61 9.61-1.374-9.61h10.983ZM10.022 13.7 20.456 3.267h3l-2.123 15.016-7.887 7.874h-1.647L10.023 13.7Zm10.176 12.457h-5.81l6.777-6.777-.967 6.777ZM10.092.667v.666a.333.333 0 1 0 .667 0V.667h3.05v.666a.333.333 0 1 0 .667 0V.667h3.046v.666a.333.333 0 1 0 .667 0V.667h3.05v.666a.333.333 0 1 0 .667 0V.667h1.613v1.93H8.48V.667h1.614Zm10.06 30.166a.5.5 0 0 1-.486.5h-7.334a.5.5 0 0 1-.5-.5v-.853h8.32v.853Z"
      />
      <path
        fill="currentColor"
        d="M16 18.744a3.087 3.087 0 1 0 .006-6.174A3.087 3.087 0 0 0 16 18.744Zm0-5.504a2.42 2.42 0 1 1 .006 4.842 2.42 2.42 0 0 1-.007-4.842Z"
      />
    </svg>
  );
}
export default DrugIcon13;
